import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../../api/api";
import "../Signup/Auth.css";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [strength, setStrength] = useState(0);

  const checkStrength = (val) => {
    let score = 0;
    if (val.length >= 8) score++;
    if (/[A-Z]/.test(val)) score++;
    if (/[0-9]/.test(val)) score++;
    if (/[^A-Za-z0-9]/.test(val)) score++;
    setStrength(score);
  };

  const strengthColors = ["#ef4444", "#f97316", "#eab308", "#16a34a"];
  const strengthLabels = ["Weak", "Fair", "Good", "Strong"];

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");

    if (password.length < 6)
      return setMessage("Password must be at least 6 characters.");
    if (password !== confirmPassword)
      return setMessage("Passwords do not match.");

    try {
      setLoading(true);
      await api.put(`/auth/reset-password/${token}`, { password });
      setIsSuccess(true);
      setMessage("Password updated successfully! Redirecting…");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Invalid or expired reset link."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">

        {/* Logo */}
        <div className="auth-logo">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none"
            xmlns="http://www.w3.org/2000/svg" className="auth-logo-svg">
            <rect width="28" height="28" rx="7" fill="#09090b"/>
            <rect x="7" y="16" width="14" height="2.5" rx="1.25" fill="white" opacity="0.4"/>
            <rect x="7" y="12" width="10" height="2.5" rx="1.25" fill="white" opacity="0.7"/>
            <rect x="7" y="8" width="6" height="2.5" rx="1.25" fill="white"/>
            <path d="M19 9.5L21.5 12L19 14.5" stroke="white" strokeWidth="1.8"
              strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span className="auth-logo-name">learnlia</span>
        </div>

        <h1 className="auth-heading">Reset your password</h1>
        <p className="auth-subheading">Choose a new password for your account.</p>

        {message && (
          <div className={isSuccess ? "auth-success-msg" : "auth-error"}>
            {message}
          </div>
        )}

        {!isSuccess && (
          <form onSubmit={handleReset}>
            <div className="auth-field">
              <label className="auth-label">New password</label>
              <input
                className="auth-input"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  checkStrength(e.target.value);
                }}
                required
                disabled={loading}
              />
              {password.length > 0 && (
                <>
                  <div className="strength-bar">
                    {[0, 1, 2, 3].map((i) => (
                      <div
                        key={i}
                        className="strength-seg"
                        style={{
                          background:
                            i < strength
                              ? strengthColors[strength - 1]
                              : "var(--auth-border)",
                        }}
                      />
                    ))}
                  </div>
                  <div
                    className="strength-label"
                    style={{ color: strengthColors[strength - 1] }}
                  >
                    {strengthLabels[strength - 1]}
                  </div>
                </>
              )}
            </div>

            <div className="auth-field">
              <label className="auth-label">Confirm password</label>
              <input
                className="auth-input"
                type="password"
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? <span className="spinner" /> : "Update password"}
            </button>
          </form>
        )}

        <div className="auth-link">
          Back to <Link to="/login">sign in</Link>
        </div>

        <hr className="auth-divider" />

        <a href="mailto:learnliadev@gmail.com" className="support-link">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.2"/>
            <path d="M6.25 6C6.25 5.03 7.01 4.25 8 4.25C8.99 4.25 9.75 5.03 9.75 6C9.75 6.83 9.2 7.52 8.45 7.8C8.18 7.9 8 8.14 8 8.43V9"
              stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
            <circle cx="8" cy="11.5" r="0.7" fill="currentColor"/>
          </svg>
          Contact support
        </a>

      </div>
    </div>
  );
}

export default ResetPassword;